<app-header></app-header>

<div class="jumbotron jumbotron-fluid bg-dark-blue">
    <div class="container flex-item mx-3 mx-md-5">
        <div class="row">
            <div class="col-12">
                <!-- <h4 class="text-center text-capitalize text-white">Welcome to</h4> -->
                <h1 class="hero-header text-light text-center extra-large py-4">About ParkUpp</h1>
                <p class="text-center text-white-50 mb-5">
                    ParkUpp is South Africa’s leading monthly parking marketplace, bridging the gap between individuals and businesses in need of parking and parking owners with available spaces.
                    Whether you’re a student seeking a spot near campus, a professional looking for long-term parking, or a parking owner aiming to monetize underutilized spaces, ParkUpp provides a
                    seamless, tech-driven solution tailored to your needs. With a focus on convenience, necessity, and flexibility, we’re committed to making parking effortless for all our users.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="listing-options container-fluid py-md-5 bg-yellow">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="mb-4">Our Why</h1>
                <p class="text-black">
                    At ParkUpp, we believe that parking shouldn’t be a hassle but an opportunity. Our mission is to unlock the potential of unused parking spaces, transforming them into valuable
                    resources for both parkers and landlords. By creating a platform that connects supply with demand, we aim to revolutionize urban mobility, empower property owners, and contribute
                    to smarter, tech-drive, and more efficient cities. Our commitment to innovation, trust, and customer-centricity drives everything we do, ensuring a better parking experience for
                    all.
                </p>
            </div>
        </div>
    </div>
</div>

<div class="meet-the-team py-md-5 bg-grey">
    <div class="container">
        <div class="row">
            <div class="col-12 py-5 text-center">
                <h1 class="">
                    <span class="hero-header text-dark text-center extra-large py-4">Meet the Team</span>
                </h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <img src="assets/images/about-us/kwanele.png" alt="Kwanele Tshabalala" class="img-fluid" />
                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Kwanele Tshabalala</h3>
                    <div class="">Managing Director, connecting with clients, landlords, and delivering value.</div>
                    <a href="https://www.linkedin.com/in/kwanele-gontse-tshabalala-8023bb9b/" target="_blank" class="d-block mt-2"> <i class="fab fa-linkedin"></i> LinkedIn </a>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <img src="assets/images/about-us/umar.png" alt="Umar Obaray" class="img-fluid" />
                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Umar Obaray</h3>
                    <div class="">Business Development Manager, driving innovation and efficiency.</div>
                    <a href="https://www.linkedin.com/in/umar-obaray-917184196/" target="_blank" class="d-block mt-2"> <i class="fab fa-linkedin"></i> LinkedIn </a>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <img src="assets/images/about-us/lesedi.png" alt="Lesedi Mokoena" class="img-fluid" />
                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Lesedi Mokoena</h3>
                    <div class="">Brand Manager, driving brand message across communication platforms.</div>
                    <a href="https://www.linkedin.com/in/lesedi-mokoena/" target="_blank" class="d-block mt-2"> <i class="fab fa-linkedin"></i> LinkedIn </a>
                </div>
            </div>

            <div class="col-12 col-lg-3 mt-4 mt-lg-0 py-5 px-4 text-center">
                <img src="assets/images/about-us/mark.png" alt="Mark Bradford" class="img-fluid" />
                <div class="after-marker">
                    <h3 class="mb-3 mt-2">Mark Bradford</h3>
                    <div class="">Director, passionate about tech solutions for the real estate industry.</div>
                    <a href="https://www.linkedin.com/in/mark-bradford-4446a4122/" target="_blank" class="d-block mt-2"> <i class="fab fa-linkedin"></i> LinkedIn </a>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
